























































































import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { UPDATE_PRODUCT_GROUP } from './updateProductGroup';
import { ProductGroup } from './ProductGroupListEdit.vue';
import { UPDATE_PRODUCT } from '@/queries/Product';
import { isGroupAnAncestor } from '@/app/ProductGroup';

@Component({
  name: 'ProductGroupOrganizer',
})
export default class ProductGroupOrganizer extends Vue {
  @Prop() private productGroup!: ProductGroup;

  @InjectReactive() productGroupsMap!: Map<string, ProductGroup>;
  @InjectReactive() allProductGroups!: ProductGroup[];

  private groupExpanded = false;
  private productsTableExpanded = false;

  private updateGroup() {
    this.$apollo.mutate({
      mutation: UPDATE_PRODUCT_GROUP,
      variables: {
        productGroup: {
          id: this.productGroup.id,
          parentGroupId: this.productGroup.parentGroupId,
        },
      },
    }).then(() => {
      this.$emit('group-updated');
    });
  }

  private updateGroupForProduct(product: ProductGroup['products'][number]) {
    this.$apollo.mutate({
      mutation: UPDATE_PRODUCT,
      variables: {
        id: product.id,
        productGroupId: product.productGroupId,
      },
      fetchPolicy: 'no-cache',
    }).then(() => {
      this.$emit('product-updated', product);
    });
  }

  private get possibleParentGroups(): ProductGroup[] {
    return this.allProductGroups
      .filter(group => !isGroupAnAncestor(this.productGroup.id, group.id, this.productGroupsMap))
      .sort();
  }
}
